export default __webpack_public_path__ + "static/media/payingguest.63c9a77e.jpg";